module.exports = __webpack_public_path__ + "static/img/bup2.063694d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/bup2.jpeg
// module id = Qq6I
// module chunks = 0